<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER QISMI -->
      <div class="header-row">
        <h2 class="page-title">Buyurtmalar</h2>
        <div class="header-actions">
          <button class="action-btn new-order-btn" @click="goToNewOrder">
            <b-icon icon="plus-circle-fill"></b-icon>
            <span>Yangi buyurtma</span>
          </button>
          <div class="filter-select-container">
            <select v-model="filterStatus" class="status-select">
              <option value="all">Barcha holatlar</option>
              <option value="new">Yangi</option>
              <option value="completed">Tugallangan</option>
              <option value="canceled">Bekor qilingan</option>
            </select>
          </div>
          <Top />
        </div>
      </div>

      <!-- JADVAL QISMI -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 60px">№</th>
                <th>SANA</th>
                <th>MIJOZ / TEL</th>
                <th>MANZIL</th>
                <th>SUMMA</th>
                <th>STATUS</th>
                <th style="width: 150px; text-align: center;">AMAL</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in filteredOrders" >
                <!-- ASOSIY QATOR -->
                <tr @click="toggleExpand(item.id)" class="main-row" :class="{ 'expanded': expandedId === item.id }">
                  <td><span class="id-badge">{{ item.id }}</span></td>

                  <td class="text-dark font-bold">{{ formatDate(item.created_at) }}</td>

                  <td>
                    <div class="font-bold text-dark">{{ item.kontragent ? item.kontragent.name : '-' }}</div>
                    <div class="text-muted small">{{ item.kontragent ? item.kontragent.phone_number : item.phone_number }}</div>
                  </td>

                  <td>
                    <span class="text-muted small">{{ item.address || '-' }}</span>
                  </td>

                  <td class="price blue">{{ formatMoney(item.summa) }}</td>

                  <td>
                    <span class="tag" :class="statusClass(item.status)">
                      {{ getStatusLabel(item.status) }}
                    </span>
                  </td>

                  <td>
                    <div class="actions">
                      <!-- Savdo qilish - faqat "new" status da -->
                      <button
                        v-if="item.status === 'new'"
                        class="action-btn pos-btn"
                        @click.stop="goToPOS(item)"
                        title="Savdo qilish (POS)"
                      >
                        <b-icon icon="cart-check-fill"></b-icon>
                        <span>Savdo</span>
                      </button>
                      <button class="icon-btn view" @click.stop="toggleExpand(item.id)" title="Ko'rish / Yopish">
                        <b-icon :icon="expandedId === item.id ? 'chevron-up' : 'chevron-down'"></b-icon>
                      </button>
                      <button class="icon-btn del" @click.stop="openDeleteModal(item)" title="O'chirish">
                        <b-icon icon="trash"></b-icon>
                      </button>
                    </div>
                  </td>
                </tr>

                <!-- KENGAYTIRILGAN QATOR - mahsulotlar ro'yxati -->
                <tr v-if="expandedId === item.id" class="detail-row">
                  <td colspan="7">
                    <div class="detail-container">

                      <!-- Izoh (xizmatlar bilan) -->
                      <div v-if="item.comment" class="comment-block">
                        <b-icon icon="chat-left-text" class="mr-1"></b-icon>
                        <span>{{ item.comment }}</span>
                      </div>

                      <!-- Mahsulotlar -->
                      <div v-if="item.products && item.products.length > 0" class="products-list">
                        <div class="products-header">
                          <b-icon icon="box-seam" class="mr-1"></b-icon>
                          Buyurtma qilingan mahsulotlar ({{ item.products.length }} ta)
                        </div>
                        <table class="inner-table">
                          <thead>
                            <tr>
                              <th>Mahsulot</th>
                              <th>Soni</th>
                              <th>Narxi</th>
                              <th>Jami</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="p in item.products" :key="p.id">
                              <td>{{ p.product ? (p.product.name || p.product.extra_name) : 'Noma\'lum' }}</td>
                              <td>{{ p.count }}</td>
                              <td>{{ formatMoney(p.price) }}</td>
                              <td class="font-bold">{{ formatMoney(p.summa) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div v-if="!item.products || item.products.length === 0" class="no-products">
                        Mahsulotlar yo'q
                      </div>

                      <!-- Xizmatlar -->
                      <div v-if="item.services && item.services.length > 0" class="products-list" style="margin-top: 12px;">
                        <div class="products-header" style="color: #a142f4;">
                          <b-icon icon="gear" class="mr-1"></b-icon>
                          Xizmatlar ({{ item.services.length }} ta)
                        </div>
                        <table class="inner-table">
                          <thead>
                            <tr>
                              <th>Xizmat nomi</th>
                              <th>Ish haqi</th>
                              <th>Peredelka</th>
                              <th>Jami</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="s in item.services" :key="s.id">
                              <td>{{ s.name }}</td>
                              <td>{{ formatMoney(s.labor_price) }}</td>
                              <td>{{ formatMoney(s.redo_price) }}</td>
                              <td class="font-bold">{{ formatMoney(Number(s.labor_price || 0) + Number(s.redo_price || 0)) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                    </div>
                  </td>
                </tr>
              </template>

              <!-- BO'SH HOLAT -->
              <tr v-if="!loading && filteredOrders.length === 0">
                <td colspan="7" class="empty-row">
                  <div class="py-5 text-center">
                    <p>Ma'lumot topilmadi</p>
                  </div>
                </td>
              </tr>

              <!-- LOADING -->
              <tr v-if="loading">
                <td colspan="7" class="text-center py-5">
                  <b-spinner variant="primary"></b-spinner>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <!-- O'CHIRISH MODALI -->
    <div v-if="showDeleteModal" class="modal-overlay" @click.self="closeDeleteModal">
      <div class="modal-box animate-pop">
        <div class="warning-icon">!</div>
        <h3>O'chirishni tasdiqlaysizmi?</h3>
        <p v-if="selectedOrder" class="text-secondary mt-2">
          <b>#{{ selectedOrder.id }}</b> buyurtma tizimdan o'chiriladi.
        </p>
        <div class="modal-btns">
          <button class="m-btn cancel" @click="closeDeleteModal">YO'Q</button>
          <button class="m-btn confirm" @click="deleteItem">HA, O'CHIRILSIN</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Top from '../Layout/Top.vue';

export default {
  name: 'ZakazIndex',
  components: { Top },
  data() {
    return {
      loading: false,
      showDeleteModal: false,
      selectedOrder: null,
      orders: [],
      filterStatus: 'all',
      expandedId: null,
    };
  },
  computed: {
    filteredOrders() {
      if (this.filterStatus === 'all') return this.orders;
      return this.orders.filter(o => o.status === this.filterStatus);
    },
  },
  mounted() {
    this.fetchOrders();
  },
  methods: {
    async fetchOrders() {
      this.loading = true;
      try {
        const response = await axios.get('/api/v1/bron');
        const payload = response.data;
        const list = Array.isArray(payload) ? payload : (payload?.data || []);
        this.orders = Array.isArray(list) ? list : [];
      } catch (error) {
        console.error("Ma'lumot olishda xato:", error);
      } finally {
        this.loading = false;
      }
    },
    toggleExpand(id) {
      this.expandedId = this.expandedId === id ? null : id;
    },
    goToNewOrder() {
      this.$router.push('/zakazlar/form');
    },
    goToPOS(item) {
      localStorage.setItem('selected_bron_id', item.id);
      this.$router.push('/chiqim/pos');
    },
    formatMoney(v) {
      if (!v) return '0';
      return Number(v).toLocaleString('ru-RU').replace(/,/g, ' ');
    },
    formatDate(ts) {
      if (!ts) return '-';
      const date = new Date(ts * 1000);
      return date.toLocaleDateString('ru-RU') + ' ' + date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
    },
    getStatusLabel(status) {
      const labels = { 'new': 'Yangi', 'completed': 'Tugallangan', 'canceled': 'Bekor qilingan' };
      return labels[status] || status;
    },
    statusClass(status) {
      if (status === 'new') return 'purple';
      if (status === 'completed') return 'green-tag';
      return 'grey';
    },
    openDeleteModal(item) {
      this.selectedOrder = item;
      this.showDeleteModal = true;
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.selectedOrder = null;
    },
    async deleteItem() {
      try {
        await axios.delete(`/api/v1/bron/id/${this.selectedOrder.id}`);
        this.orders = this.orders.filter(o => o.id !== this.selectedOrder.id);
        this.closeDeleteModal();
      } catch (error) {
        alert("O'chirishda xatolik yuz berdi");
      }
    },
  }
};
</script>

<style scoped>
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.status-select {
  height: 40px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 0 15px;
  font-weight: 700;
  color: #475569;
  outline: none;
  background: white;
  cursor: pointer;
}

.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 18px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}

.custom-table td {
  padding: 14px 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 15px;
}

.main-row { cursor: pointer; transition: background 0.15s; }
.main-row:hover td { background: #fafbff; }
.main-row.expanded td { background: #f8f5ff; }

.detail-row td {
  background: #f9fafb;
  padding: 0 !important;
  border-bottom: 2px solid #e2e8f0;
}

.detail-container {
  padding: 16px 20px;
}

.comment-block {
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  color: #92400e;
  margin-bottom: 12px;
}

.products-header {
  font-size: 13px;
  font-weight: 700;
  color: #475569;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e2e8f0;
}

.inner-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.inner-table th {
  text-align: left;
  padding: 8px 10px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.inner-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
}

.no-products {
  text-align: center;
  color: #94a3b8;
  padding: 12px;
  font-size: 13px;
}

.id-badge {
  background: #f1f5f9;
  padding: 4px 10px;
  border-radius: 8px;
  font-weight: 700;
  color: #64748b;
  font-size: 13px;
}

.price.blue { color: #2563eb; font-weight: 800; }

.tag {
  padding: 5px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  display: inline-block;
}

.tag.grey     { background: #f1f5f9; color: #475569; }
.tag.purple   { background: #f5f3ff; color: #a142f4; }
.tag.green-tag { background: #ecfdf5; color: #10b981; }

.actions { display: flex; gap: 8px; justify-content: center; align-items: center; }

.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;
}

.view { background: #f5f3ff; color: #a142f4; }
.del  { background: #fff1f2; color: #e11d48; }

.action-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 36px;
  padding: 0 12px;
  border-radius: 10px;
  border: none;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.2s;
}

.pos-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 3px 10px rgba(16, 185, 129, 0.3);
}

.pos-btn:hover { box-shadow: 0 5px 15px rgba(16, 185, 129, 0.4); }

.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(15, 23, 42, 0.3);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-box {
  background: white;
  padding: 35px;
  border-radius: 28px;
  width: 420px;
  text-align: center;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.1);
}

.warning-icon {
  width: 60px; height: 60px;
  background: #fee2e2; color: #ef4444;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 30px; font-weight: bold;
  margin: 0 auto 20px;
}

.modal-btns { display: flex; gap: 12px; margin-top: 30px; }

.m-btn {
  flex: 1;
  padding: 14px;
  border-radius: 14px;
  border: none;
  font-weight: 700;
  cursor: pointer;
}

.cancel  { background: #f1f5f9; color: #64748b; }
.confirm { background: #e11d48; color: white; }

.animate-pop { animation: pop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); }

@keyframes pop {
  0%   { transform: scale(0.9); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

.font-bold { font-weight: 700; }
.text-dark { color: #1e293b; }
.text-muted { color: #94a3b8; }
.small { font-size: 12px; }

/* Yangi buyurtma tugmasi */
.new-order-btn {
  background: linear-gradient(135deg, #a142f4 0%, #7c3aed 100%);
  color: white;
  box-shadow: 0 3px 10px rgba(161, 66, 244, 0.3);
}
.new-order-btn:hover { box-shadow: 0 5px 15px rgba(161, 66, 244, 0.4); }
</style>
